import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-email-jobs-tab-1-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './configuration-email-jobs-tab-1.part.html',
})

export class ConfigurationEmailJobsTab1Part {
}
